import React, { useEffect, useContext } from "react";
import { CircularProgress, Backdrop } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";

import clsx from "clsx";
import Navbar from "./Navbar";
import { AppContext } from "../../hooks/AppContext";
import { publicApiGET } from "../../components/PrivateRoute";
import Api from "../../components/Api";
import { validateObjectData } from "../../utils";

const useStyles = makeStyles((theme) => ({
  mainSection: {
    //padding: "35px 0",
    transition: "padding 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    "&.noSidebar": {
      [theme.breakpoints.up("md")]: {
        paddingLeft: "20px",
      },
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "15px !important",
      paddingRight: "15px !important",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    background: "#fff",
  },
}));

const MainLayout = ({}) => {
  const { appState, setAppState } = useContext(AppContext);

  // FETCH - States
  const handleAppInitiate = () => {
    setAppState((prev) => ({
      ...prev,
      isStateDataLoading: true,
    }));

    publicApiGET(Api.getStates)
      .then((response) => {
        const { data, status } = response;

        if (status === 200) {
          const isDataAvailable = validateObjectData(data);
          const [firstState] = Object.keys(data);
          setAppState((prev) => ({
            ...prev,
            statesData: isDataAvailable ? data : {},
            stateSelected: isDataAvailable ? firstState : "",
            sourceSelected: isDataAvailable ? data[firstState][0] : "",
          }));
        }
      })
      .catch((error) => {
        console.log("FETCH STATES API ERROR ---> ", error);
        setAppState((prev) => ({
          ...prev,
          statesData: {},
          stateSelected: "",
          sourceSelected: "",
        }));
      })
      .finally(() => {
        console.log("FETCH STATES API EXECUTED!");
        setAppState((prev) => ({
          ...prev,
          isStateDataLoading: false,
          initialAppLoading: false,
        }));
      });
  };

  useEffect(() => {
    handleAppInitiate();
  }, []);

  const classes = useStyles();
  return (
    <>
      <Backdrop open={appState.initialAppLoading} sx={{ bgcolor: "transparent" }}>
        <CircularProgress color="primary" />
      </Backdrop>

      {!appState.initialAppLoading && (
        <div className={classes.content}>
          <div className={classes.headerSection}>
            <Navbar />
          </div>

          <div
            className={clsx({
              [classes.mainSection]: true,
            })}
          >
            <Outlet />
          </div>
        </div>
      )}
    </>
  );
};

export default MainLayout;
